// @flow
/**
 * @module Epics/categoria
 * @desc Categoria
 */

import { ActionTypes } from '../utils/constants';
import { ofType, ActionsObservable } from 'redux-observable';
import { switchMap, map, catchError } from 'rxjs/operators';
import { BaseApiService } from '../utils/BaseApiService';
import { fetchVersionSuccess, fetchVersionFailure, fetchCouponSuccess, sendCouponFinalized } from '../actions';
import { of } from 'rxjs';

export function fetchVersion(action$: ActionsObservable, store) {
  return action$.pipe(
    ofType(ActionTypes.FETCH_VERSION_REQUEST),
    switchMap(action => {
      return BaseApiService.get(`/api/cotizador/${action.payload.tipo}/${action.payload.modelo}/`).pipe(
        map(({ response }) => {
          return fetchVersionSuccess(response);
        }),
        catchError(
          /* istanbul ignore next  */ ({ actions = [] }) =>
            of(fetchVersionFailure(), ...actions)
        )
      );
    })
  );
}

export function fetchCoupon(action$: ActionsObservable, store) {
  return action$.pipe(
    ofType(ActionTypes.REQUEST_COUPON),
    switchMap(action => {
      return BaseApiService.get(`/api/cotizador/cupon/${action.payload.coupon}/`).pipe(
        map(({ response: { data } }) => {
          return fetchCouponSuccess(data);
        }),
        catchError(
          /* istanbul ignore next  */ ({ actions = [] }) =>
            of(fetchCouponSuccess(false), ...actions)
        )
      );
    })
  );
}

export function sendCouponInfo(action$: ActionsObservable, store) {
  return action$.pipe(
    ofType(ActionTypes.SEND_COUPON_REQUEST),
    switchMap(action => {
      const payload = Object.keys(action.payload.form).reduce((acc, curr) => {
        return {
          ...acc,
          [`info[${curr}]`]: action.payload.form[curr]
        }
      }, {});
      return BaseApiService.post(`/api/cotizador/cupon/${action.payload.form.coupon}/enviar/`, payload).pipe(
        map(({ response: { data } }) => {
          return sendCouponFinalized();
        }),
        catchError(
          /* istanbul ignore next  */ ({ actions = [] }) =>
            of(sendCouponFinalized(false), ...actions)
        )
      );
    })
  );
};